/**
 * マーク掲載順更新
 *
 * @export UpdateMarkPublishOrderVo
 * @class UpdateMarkPublishOrderVo
 */
export class UpdateMarkPublishOrderVo {
    constructor(
        public markCode: string,
        public publishOrder: string,
    ) {}
}
